<template>
    <nav class="navbar">
        <div class="nav-content">
            <a href="/">
                <div class="logo">INOVARE</div>
            </a>
            <!-- Enhanced Hamburger Button -->
            <div class="hamburger" id="hamburger">
                <div class="hamburger-container">
                    <span class="bar bar1"></span>
                    <span class="bar bar2"></span>
                    <span class="bar bar3"></span>
                </div>
                <div class="menu-text">MENU</div>
            </div>
            <!-- Desktop Navigation -->
            <ul class="nav-links desktop-nav">
                <li><router-link to="/"><a>Home</a></router-link></li>
                <li><router-link to="/about"><a>About</a></router-link></li>
                <li><router-link to="/meet-the-team"><a>Meet The Team</a></router-link></li>
                <li><router-link to="/events"><a>Events</a></router-link></li>
                <li><router-link to="/contact"><a>Contact</a></router-link></li>
            </ul>
        </div>
        <!-- Mobile Menu Overlay -->
        <div class="mobile-menu-overlay" id="mobileMenuOverlay">
            <div class="mobile-menu-content">
                <div class="menu-header">
                    <div class="menu-logo">INOVARE</div>
                </div>
                <nav class="mobile-nav">
                    <ul class="mobile-nav-links">
                        <li><router-link to='/'>
                            <a class="nav-item">
                                <span class="nav-number">01</span>
                                <span class="nav-text">Home</span>
                                <span class="nav-icon">🏠</span>
                            </a>
                        </router-link>
                        </li>
                        <li><router-link to='/about'>
                            <a class="nav-item">
                                <span class="nav-number">02</span>
                                <span class="nav-text">About</span>
                                <span class="nav-icon">💡</span>
                            </a>
                        </router-link>
                        </li>
                        <li><router-link to='/meet-the-team'>
                            <a class="nav-item">
                                <span class="nav-number">03</span>
                                <span class="nav-text">Meet The Team</span>
                                <span class="nav-icon">💡</span>
                            </a>
                        </router-link>
                        </li>
                        <li><router-link to='/events'>
                            <a class="nav-item">
                                <span class="nav-number">04</span>
                                <span class="nav-text">Events</span>
                                <span class="nav-icon">🎯</span>
                            </a>
                        </router-link>
                        </li>
                        <li><router-link to='/contact'>
                            <a class="nav-item">
                                <span class="nav-number">05</span>
                                <span class="nav-text">Contact</span>
                                <span class="nav-icon">📧</span>
                            </a>
                        </router-link>
                        </li>
                    </ul>
                </nav>
                <div class="menu-footer">
                    <div class="social-links">
                        <a class="social-link" href="https://www.linkedin.com/company/inovare-io/"><span>LinkedIn</span></a>
                        <a class="social-link" href="https://www.instagram.com/inovare.io"><span>Instagram</span></a>
                        <a class="social-link" href="mailto:team.inovare@gmail.com"><span>Email</span></a>
                    </div>
                    <div class="menu-tagline">Empowering Innovation • Connecting Minds</div>
                </div>
            </div>
            <div class="menu-bg-elements">
                <div class="floating-element element-1"></div>
                <div class="floating-element element-2"></div>
                <div class="floating-element element-3"></div>
                <div class="floating-element element-4"></div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: "AppNavbar",
}
</script>

<style scoped>
/deep/a:-webkit-any-link {
    text-decoration: none !important;
}

.mobile-menu-content{
    height: 100vh !important;
    background: rgba(0,0,0,0.95);
}
</style>